import SPP from '../../css/special-pack.module.css';
import sppPageLogo from '../../img/special-pack/sppPageLogo.svg';

const HomeHeader = () => {
    return (
        <section>
            <div className={SPP.pageTitle}>
                <img src={sppPageLogo} alt="お得な新幹線往復日帰りパック" />
            </div>
            <div className={SPP.areaTitle}>
                <p>東京方面 発</p>
            </div>
            <div className={SPP.pageDescript}>
                <p>観光にもビジネスにも！東京方面発の新幹線をご利用なら、ジョルダンMaaSパッケージの日帰りパックがだんぜんお得！ご利用希望の区間を料金表から選択して、「お問い合わせ」ボタンからジョルダンへお気軽にお問い合せください。</p>
            </div>
        </section>
    );
}

export default HomeHeader;